import React from 'react';
import Loadable from '@components/Loadable';
import { lazy } from 'react';

const Transactions = Loadable(lazy(() => import('./Transactions')));
const WalletTransactionHistory = Loadable(lazy(() => import('./WalletTransactionHistory')));
const ManageBills = Loadable(lazy(() => import('./ManageBills')));
const MonthlyReconciliation = Loadable(lazy(() => import('./MonthlyReconciliation')));
const ManageWithdrawal = Loadable(lazy(() => import('../AdminPage/ManageWithdrawal')));

const accountingRouters = [
  { path: '/accounting/transactions', element: <Transactions /> },
  { path: '/accounting/walletTransactionHistory', element: <WalletTransactionHistory /> },
  { path: '/accounting/manageBills', element: <ManageBills /> },
  { path: '/accounting/monthlyReconciliation', element: <MonthlyReconciliation /> },
  { path: '/accounting/withdrawals', element: <ManageWithdrawal /> }
];

export default accountingRouters;
